import React from 'react';
import Pagehelmet from './Pagehelmet';
import { FaGlobe, FaLightbulb, FaBullhorn, FaHandshake, FaVideo, FaChartLine, FaHome } from 'react-icons/fa';

const BenefitsSpeaker = () => {
  const benefits = [
    {
      icon: <FaGlobe size={24} />,
      title: "Global Exposure",
      desc: "Present to a worldwide audience of industry professionals, policymakers, and innovators from key oil & gas markets including the USA, Middle East, and Asia-Pacific."
    },
    {
      icon: <FaLightbulb size={24} />,
      title: "Thought Leadership",
      desc: "Position yourself as a leading voice in the energy transition, digital oilfield, AI innovation, and sustainability."
    },
    {
      icon: <FaBullhorn size={24} />,
      title: "Brand Visibility",
      desc: "Your name, title, and company will be featured across our event website, promotional materials, email campaigns, and social media channels."
    },
    {
      icon: <FaHandshake size={24} />,
      title: "High-Value Networking",
      desc: "Connect with fellow speakers, executives, and attendees in curated networking sessions, speaker lounges, and virtual roundtables."
    },
    {
      icon: <FaVideo size={24} />,
      title: "Session Recording",
      desc: "Receive a high-quality recording of your session for use in personal branding, company PR, or internal learning."
    },
    {
      icon: <FaChartLine size={24} />,
      title: "Lead Generation",
      desc: "Gain access to post-event analytics and attendee engagement insights (for opted-in participants)."
    },
    {
      icon: <FaHome size={24} />,
      title: "No Travel Required",
      desc: "Engage globally without the cost or logistics of travel. Present from your office, studio, or home."
    },
  ];

  return (
    <div>
      <Pagehelmet pageTitle="Speaker Benefits" />

      {/*-- Speaker Detail section starts --*/}
      <section className="speaker-detail py-5">
        <div className="container">
          <div className="inner-speaker-detail text-center">
            <div className="row justify-content-center">
              {/* Full-width Column */}
              <div className="col-lg-10">
                <div className="speaker-detail-left py-2">

                  {/* Biography */}
                  <div className="biography mb-5">
                    <h4 className="fw-bold mb-3 text-dark text-center">
                      Why Speak at FutureOil 2026
                    </h4>
                    <p className="mb-3 text-muted text-center">
                      Our conference speakers are global energy leaders, AI experts, and
                      data-driven innovators shaping the <strong>net-zero energy transition</strong>. 
                      They bring decades of experience from across oil, gas, renewables, 
                      digital technologies, and government policy.
                    </p>
                    <p className="text-muted text-center">
                      Each speaker at <strong>Future Oil Conference 2026</strong> contributes insights on 
                      how artificial intelligence, advanced data analytics, and innovative solutions can 
                      accelerate the journey toward a cleaner, more sustainable energy future.
                    </p>
                  </div>

                  {/* Benefits for Speakers */}
                  <div className="conference-topics mb-5">
                    <h4 className="fw-bold mb-4 text-dark text-center">Benefits for Speakers</h4>
                    <div className="row g-4">
                      {benefits.map((topic, index) => (
                        <div key={index} className="col-md-6 d-flex">
                          <div
                            style={{
                              width: "50px",
                              height: "50px",
                              background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                              color: "#fff",
                              borderRadius: "12px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                              marginRight: "15px",
                              boxShadow: "0 4px 10px rgba(37,117,252,0.35)",
                            }}
                          >
                            {topic.icon}
                          </div>
                          <div style={{ maxWidth: "400px", textAlign: "left" }}>
                            <h5
                              style={{
                                fontWeight: "700",
                                fontSize: "1rem",
                                marginBottom: "6px",
                                color: "#222",
                              }}
                            >
                              {topic.title}
                            </h5>
                            <p
                              style={{
                                fontSize: "0.95rem",
                                lineHeight: "1.6",
                                color: "#555",
                                margin: 0,
                              }}
                            >
                              {topic.desc}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Why FutureOil */}
                  <div className="personal-info">
                    <h4 className="fw-bold mb-3 text-dark text-center">Why FutureOil?</h4>
                    <p className="text-muted text-center">
                      By joining FutureOil 2026 as a speaker, you become part of a global platform that 
                      doesn’t just discuss the future — it defines it. Together, we highlight solutions 
                      that drive innovation, digital transformation, and progress toward net-zero.
                    </p>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*-- Speaker Detail section ends --*/}
    </div>
  );
};

export default BenefitsSpeaker;
